// extracted by mini-css-extract-plugin
export default {"pageContainer":"PageLayout_pageContainer__Iti2W","content":"PageLayout_content__wDMds","closeButton":"PageLayout_closeButton__4ZY6-"};